import { useEffect, useState } from 'react';
import { mainlineApi } from '@services/drbfm.mainline';

/** `unavailable` (the check failed) is kept apart from `disabled` (the tenant flag is off). */
export type MainlineStatus = 'checking' | 'enabled' | 'disabled' | 'unavailable';

type Tenant = string | null | undefined;

export function useMainlineStatus(tenantId: Tenant): MainlineStatus {
  // A new token on every tenant change (A→B→A included), so an earlier answer never stands for a new check.
  const [epoch, setEpoch] = useState(() => ({ tenantId }));
  if (epoch.tenantId !== tenantId) setEpoch({ tenantId });
  const [answer, setAnswer] = useState<{ epoch: object; status: MainlineStatus } | null>(null);
  useEffect(() => {
    let cancelled = false;
    const settle = (status: MainlineStatus) => { if (!cancelled) setAnswer({ epoch, status }); };
    mainlineApi.status()
      .then(result => settle(result.enabled ? 'enabled' : 'disabled'))
      .catch(() => settle('unavailable'));
    return () => { cancelled = true; };
  }, [epoch]);
  return epoch.tenantId === tenantId && answer?.epoch === epoch ? answer.status : 'checking';
}
